<template>
  <div>
    <div class="col-9 ms-auto me-5 px-3">
      <div class="col-12 d-flex justify-content-between align-items-end p-0 my-4">
        <span class="body-title">Listado de Productos</span>

        <div>
          <button
            id="modal-open"
            type="button"
            class="btn btn-success"
            data-bs-toggle="modal"
            data-bs-target="#addProduct"
            @click="clearFormVariables()"
          >
            <i class="fa-solid fa-plus me-2"></i>
            Agregar producto
          </button>
          <!-- <input type="file" ref="fileInput" @change="handleFileUpload"> -->
        </div>
      </div>

      <div class="content-view">
        <paginate ref="paginator" name="elements" :list="products" :per="15" :async="true">
          <div class="col-5">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar producto(s)"
              v-model="productSearch"
              @keyup="searchProducts()"
            />
          </div>
          <table class="table table-hover mt-3">
            <thead>
              <th class="col">Nombre</th>
              <th class="col">Impuestos (ITBIS)</th>
              <th class="col">SKU</th>
              <th class="col">Unidades</th>
              <th class="col">Precio</th>
              <th class="col">Costo</th>
            </thead>

            <tbody class="position-relative">
              <tr
                v-for="(product, i) in paginated('elements')"
                :key="i"
                @click="openModalForEdit(product)"
                :id="`product-row-${i}`"
                @mouseenter="addOrRemoveDeleteOptClass($event)"
                @mouseleave="addOrRemoveDeleteOptClass($event)"
              >
                <td>{{ product.name }}</td>
                <td>{{ product.taxes }}</td>
                <td class="text-uppercase">{{ product.sku }}</td>
                <td>{{ product.units }}</td>
                <td>RD$ {{ product.price }}</td>
                <td>RD$ {{ product.cost }}</td>
                <td class="deleteOpt text-danger" @click.stop="confirmMessage(product.id)">
                  <i class="bi bi-trash-fill"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </paginate>
        <div class="">
          <paginate-links
            for="elements"
            :limit="9"
            :hide-single-page="true"
            :show-step-links="true"
            :step-links="{
              next: '  ❯',
              prev: '❮  ',
            }"
          >
          </paginate-links>
        </div>
      </div>

      <!-- Modals -->
      <!-- Add or Edit Product -->
      <div
        class="modal fade"
        id="addProduct"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold">{{ product_id ? "Editar producto" : "Agregar producto" }}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <form @submit.prevent="product_id ? updateProduct() : saveProduct()">
                <div class="d-flex justify-content-between col-12 my-2">
                  <div class="col-5 form-group">
                    <label for="">Nombre:</label>
                    <input
                      id="name"
                      @keydown.enter="enterAsTab"
                      @input="checkPropertyModified('name')"
                      type="text"
                      name="name"
                      class="form-control"
                      v-model="product.name"
                      required
                    />
                  </div>
                  <div class="col-5 form-group">
                    <label for="">Impuesto fijo:</label>
                    <CurrencyInput
                      @keydown.enter="enterAsTab"
                      @input="checkPropertyModified('taxes')"
                      type="text"
                      name="taxes"
                      max="100"
                      class="form-control"
                      v-model="product.taxes"
                      required
                    ></CurrencyInput>
                  </div>
                </div>

                <div class="d-flex justify-content-between col-12 my-2">
                  <div class="col-5 form-group">
                    <label for="">Precio:</label>
                    <CurrencyInput
                      @keydown.enter="enterAsTab"
                      @input="checkPropertyModified('price')"
                      type="text"
                      name="price"
                      class="form-control"
                      v-model="product.price"
                      required
                    ></CurrencyInput>
                  </div>
                  <div class="col-5 form-group">
                    <label for="">Costo:</label>
                    <CurrencyInput
                      @keydown.enter="enterAsTab"
                      @input="checkPropertyModified('cost')"
                      type="text"
                      name="cost"
                      class="form-control"
                      v-model="product.cost"
                      required
                    ></CurrencyInput>
                  </div>
                </div>

                <div class="d-flex justify-content-between col-12 my-2 mb-4">
                  <div class="col-5 form-group">
                    <label for="">Unidades:</label>
                    <CurrencyInput
                      @keydown.enter="enterAsTab"
                      @input="checkPropertyModified('units')"
                      type="text"
                      name="units"
                      class="form-control"
                      v-model="product.units"
                      required
                    ></CurrencyInput>
                  </div>

                  <div class="col-5 form-group">
                    <label for="">SKU (opcional):</label>
                    <input
                      @input="checkPropertyModified('sku')"
                      type="text"
                      name="sku"
                      class="form-control"
                      v-model="product.sku"
                    />
                  </div>
                </div>

                <div class="modal-footer">
                  <section>
                    <button type="submit" class="btn btn-success" aria-label="Close" :disabled="!isModified">
                      {{ product_id ? "Actualizar producto" : "Añadir producto" }}
                    </button>
                  </section>
                  <button
                    id="modal-close"
                    type="button"
                    class="btn btn-danger"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cerrar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePaginate from "vue-paginate";
import CurrencyInput from "../CurrencyInputComponent.vue";

export default {
  components: {
    VuePaginate,
    CurrencyInput,
  },
  data() {
    return {
      product_id: 0,
      isModified: false,
      products: [],
      product: {
        name: "",
        taxes: "",
        price: "",
        cost: "",
        units: "",
        sku: "",
      },
      productSearch: null,
      productsToDelete: [],
      paginate: ["elements"],
    };
  },
  computed: {
    productsFilter() {
      return this.products.filter();
    },
  },
  methods: {
    checkPropertyModified(property) {
      this.isModified = this.isPropertyModified(property);
    },

    isPropertyModified(property) {
      return this.product[property] !== this.originalProduct[property];
    },

    openModal() {
      const myModal = new bootstrap.Modal(document.querySelector("#addProduct"), {});
      myModal.show();
      this.focus("name");
    },

    searchProducts() {
      axios
        .get("invoice/all-products", {
          params: {
            search: this.productSearch,
          },
        })
        .then((response) => {
          this.products = [];
          this.products = response.data.products;
          this.$refs.paginator.currentPage = 0;
        });
    },

    getProducts() {
      axios.get("/invoice/all-products").then((response) => {
        this.products = response.data.products;
        this.product.sku = `LNA-${response.data.sku}`;
      });
    },

    saveProduct() {
      if (this.product.price > this.product.cost) {
        axios.post("product", this.product).then((response) => {
          if (response.data.success) {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: response.data.success,
            });

            this.getProducts();
            this.clearFormVariables();
            document.getElementById("modal-close").click();
          } else {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "error",
              title: response.data.error,
            });
          }
        });
      } else {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "error",
          title: "El costo del producto no puede ser mayor al precio del mismo",
        });
      }
    },

    openModalForEdit(product) {
      this.product_id = true;
      this.product = { ...product };
      this.originalProduct = { ...product };
      this.openModal();
    },

    updateProduct() {
      axios.put(`/product/${this.product.id}`, this.product)
      .then((response) => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });

        if (response.data.success) {
          Toast.fire({
            icon: "success",
            title: response.data.success,
          });

          this.getProducts()
          this.productSearch = "";
          document.getElementById('modal-close').click();
        } else {
          Toast.fire({
            icon: "error",
            title: response.data.error,
          });
        }
      });
    },

    deleteProduct(id){
      axios.delete(`/product/${id}`)
      .then(response => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });

        if(response.data.success) {
          Toast.fire({
            icon: "success",
            title: response.data.success,
          });

          this.productSearch = "";
          this.getProducts();
        } else {
          Toast.fire({
            icon: "error",
            title: response.data.error,
          });
        }
      });
    },

    addProductsToDelete(product) {
      let i = this.productsToDelete.findIndex((el) => el.id == product.id)(i == -1)
        ? this.productsToDelete.push(product)
        : this.productsToDelete.splice(i, 1);
    },

    confirmDeleteMessage() {
      Swal.fire({
        title: `¿Deseas eliminar estos productos?`,
        showDenyButton: true,
        confirmButtonText: "Sí",
      }).then((response) => {
        this.productsSelected();
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "success",
          title: response.data.success,
        });
      });
    },
    // comentar
    productsSelected(){
      axios.delete(`/product/destroy-products/`, {
        params: {
          products: this.productsToDelete,
        },
      });
    },

    confirmMessage(id) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "¿Está seguro?",
          text: "¡No podrás revertir esto!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "¡Sí, bórralo!",
          cancelButtonText: "¡No, cancela!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteProduct(id);
            //   this.getProducts();
          }
        });
    },

    clearFormVariables() {
      this.product_id = false;
      this.product = {
        name: "",
        taxes: "0.00",
        price: "0.00",
        cost: "0.00",
        units: "0.00",
        sku: "",
      };
      (this.originalProduct = {}), this.focus("name");
      this.getProducts();
    },

    uploadData(data) {
      axios.post("product/upload", { data }).then((response) => {
        if (response.data.success) {
          this.swal.fire({
            icon: "success",
            text: response.data.success,
            timer: 3000,
          });
        } else {
          this.swal.fire({
            icon: "error",
            text: response.data.error,
            timer: 3000,
          });
        }
      });
    },

    handleFileUpload() {
      const file = this.$refs.fileInput.files[0];
      const reader = new FileReader(file);
      reader.onload = () => {
        const workbook = XLSX.read(reader.result, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        console.log("entrando");
        this.uploadData(data);
      };
      reader.readAsBinaryString(file);
    },
  },
  created() {
    this.getProducts();
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  label {
    color: var(--first-color-dark);
  }
}

.invoice-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* Table styles */
table {
  th {
    color: var(--first-color-dark);
  }

  td {
    padding: 0 !important;
  }

  .selected {
    background: #c3c2c2;
  }

  .table-footer {
    border: white;
  }
}

.modal-body {
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgb(57, 48, 48);
    border-radius: 10px;
  }
}

.paragraph {
  color: var(--first-color-dark);
}

.label-form {
  color: var(--first-color-dark);
}

div.swal2-actions {
  width: 50% !important;
  justify-content: space-around !important;
}
</style>
